import React from 'react';
import { Link } from 'react-router-dom';
import { Event } from '../types';
import { useTranslation } from 'react-i18next';
import EventCard from './EventCard';
import EmptyEventsState from './EmptyEventsState';
import EventsSkeleton from './EventsSkeleton';

interface EventsSectionProps {
  readonly events: Event[];
  readonly loading: boolean;
  readonly city?: string | null;
}

const EventsSection: React.FC<EventsSectionProps> = ({ events, loading, city }) => {
  const { t } = useTranslation();

  return (
    <section className="px-4 md:px-margin-desktop py-12 max-w-container mx-auto">
      {/* Featured — horizontal scroll row */}
      <div className="mb-12 -mx-4 md:-mx-margin-desktop">
        <div className="px-4 md:px-margin-desktop mb-4 flex justify-between items-end">
          <h2 className="font-headline text-headline-sm text-on-surface">
            {city ? t('home.eventsInCity', { city }) : 'Eventos em Destaque'}
          </h2>
          <Link
            to={city ? `/events?city=${encodeURIComponent(city)}` : '/events'}
            className="font-headline text-label-sm text-primary hover:underline"
          >
            {t('home.viewAll')}
          </Link>
        </div>

        {loading ? (
          <div className="px-4 md:px-margin-desktop">
            <EventsSkeleton />
          </div>
        ) : events.length > 0 ? (
          <div className="flex overflow-x-auto gap-5 px-4 md:px-margin-desktop pb-2 no-scrollbar">
            {events.slice(0, 6).map((event) => (
              <div key={event.id} className="flex-shrink-0 w-72">
                <EventCard event={event} variant="card" />
              </div>
            ))}
          </div>
        ) : (
          <div className="px-4 md:px-margin-desktop">
            <EmptyEventsState city={city} />
          </div>
        )}
      </div>

      {/* Upcoming — vertical list */}
      {!loading && events.length > 6 && (
        <div>
          <h2 className="font-headline text-headline-sm text-on-surface mb-6">Próximos para você</h2>
          <div className="space-y-4">
            {events.slice(6).map((event) => (
              <EventCard key={event.id} event={event} variant="horizontal" />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};

export default EventsSection;
